<script setup lang="ts">
import { components } from '~/slices'

const { client } = usePrismic()
const route = useRoute()
const { data: branch } = await useAsyncData(
  `branch-${route.params.uid}`,
  () => client.getByUID('branch', route.params.uid as string),
)

useDocumentSeo(branch)
</script>

<template>
  <main>
    <SliceZone :slices="branch?.data.slices ?? []" :components="components" />
  </main>
</template>
